import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';
import { UtilitariosService } from './utilitarios.service';
import { HeaderAdicionales, HeaderDatos } from '../models/generic/HeaderDatos';
import { Observable } from 'rxjs/internal/Observable';
import { Constantes } from '../models/modules/Constantes';

@Injectable({
  providedIn: 'root'
})
export class ComunicacionapiService {
  _Header : HttpHeaders;
  _HeaderAutorizacion : HttpHeaders;
  
  constructor(private httpClient: HttpClient,
              public autenticacionService: AutenticacionService,
              public utilitariosService: UtilitariosService) {
  
  }

  Get(rutaWebApi: string, incluirHeader: boolean = true, listaHeaders: HeaderAdicionales[] = []) : Observable<any> {
    if (incluirHeader) {
      this.ObtenerHeadersLlamado();
    }

    if (this.utilitariosService.VerificarContieneDatos(listaHeaders)) {
      for(let _Encabezado of listaHeaders) {
        this._Header = this._Header.append(_Encabezado.codigo, _Encabezado.valor);
      }
    }

    return this.httpClient.get<any>(rutaWebApi, {headers:this._Header});
  }
  GetAutorization(rutaWebApi: string, incluirHeader: boolean = true) : Observable<any> {
    if (incluirHeader) {
      this.ObtenerHeadersLlamado();
    }

    return this.httpClient.get<any>(rutaWebApi, {headers:this._HeaderAutorizacion});
  }

  Put(rutaWebApi: string, parametro: any = null, incluirHeader: boolean = true, listaHeaders: HeaderAdicionales[] = []): Observable<any> {
    if (incluirHeader) {
      this.ObtenerHeadersLlamado();
    }

    if (this.utilitariosService.VerificarContieneDatos(listaHeaders)) {
      for(let _Encabezado of listaHeaders) {
        this._Header = this._Header.append(_Encabezado.codigo, _Encabezado.valor);
      }
    }

    return this.httpClient.put<any>(rutaWebApi, parametro, { headers: this._Header});
  }
  PutAutorization(rutaWebApi: string, parametro: any = null, incluirHeader: boolean = true): Observable<any> {
    if (incluirHeader) {
      this.ObtenerHeadersLlamado();
    }

    return this.httpClient.put<any>(rutaWebApi, parametro, { headers: this._HeaderAutorizacion});
  }

  Post(rutaWebApi: string, parametro: any = null, incluirHeader: boolean = true, listaHeaders: HeaderAdicionales[] = []) : Observable<any> {
    if (incluirHeader) {
      this.ObtenerHeadersLlamado();
    }

    if (this.utilitariosService.VerificarContieneDatos(listaHeaders)) {
      for(let _Encabezado of listaHeaders) {
        this._Header = this._Header.append(_Encabezado.codigo, _Encabezado.valor);
      }
    }

    return this.httpClient.post<any>(rutaWebApi, parametro, { headers: this._Header});
  }
  PostAutorization(rutaWebApi: string, parametro: any = null, incluirHeader: boolean = true) : Observable<any> {
    if (incluirHeader) {
      this.ObtenerHeadersLlamado();
    }

    return this.httpClient.post<any>(rutaWebApi, parametro, { headers: this._HeaderAutorizacion});
  }
  PostDescarga(rutaWebApi: string, parametro: any = null, incluirHeader: boolean = true, listaHeaders: HeaderAdicionales[] = []) : Observable<any> {
    if (incluirHeader) {
      this.ObtenerHeadersLlamado();
    }

    if (this.utilitariosService.VerificarContieneDatos(listaHeaders)) {
      for(let _Encabezado of listaHeaders) {
        this._Header = this._Header.append(_Encabezado.codigo, _Encabezado.valor);
      }
    }

    return this.httpClient.post<any>(rutaWebApi, parametro, { headers: this._Header, responseType: 'blob' as 'json'});
  }

  Delete(rutaWebApi: string, parametro: any = null, incluirHeader: boolean = true, listaHeaders: HeaderAdicionales[] = []) : Observable<any> {
    if (incluirHeader) {
      this.ObtenerHeadersLlamado();
    }

    if (this.utilitariosService.VerificarContieneDatos(listaHeaders)) {
      for(let _Encabezado of listaHeaders) {
        this._Header = this._Header.append(_Encabezado.codigo, _Encabezado.valor);
      }
    }

    let options = {
      headers: incluirHeader ? this._Header : null,
      body: parametro
    }
    
    return this.httpClient.delete<any>(rutaWebApi, options);
  }
  DeleteAutorization(rutaWebApi: string, parametro: any = null, incluirHeader: boolean = true) : Observable<any> {
    if (incluirHeader) {
      this.ObtenerHeadersLlamado();
    }

    let options = {
      headers: incluirHeader ? this._HeaderAutorizacion : null,
      body: parametro
    }
    
    return this.httpClient.delete<any>(rutaWebApi, options);
  }

  async ObtenerHeadersLlamado() {
    let token: string = '';
    let tokenAutorizacion: string = '';
    let datosHeader: HeaderDatos = new HeaderDatos();

    if (this.utilitariosService.VerificarContieneDatos(this.autenticacionService.UsuarioActivo)) {
      datosHeader.usuario = this.autenticacionService.UsuarioActivo.usuario;
      datosHeader.recaptcha = this.autenticacionService.Recaptcha;
      datosHeader.ipCliente = this.autenticacionService.UsuarioActivo.ipCliente;
      datosHeader.idAplicacion = this.autenticacionService.AplicacionSeleccionadoInicial;
      datosHeader.idAliado = this.autenticacionService.AliadoSeleccionadoInicial;
      datosHeader.idCanal = this.autenticacionService.CanalSeleccionadoInicial;
      datosHeader.canal = this.autenticacionService.DescripcionCanalSeleccionadoInicial;
      datosHeader.consultamultiusuario = this.autenticacionService.RolMulticonsulta;
      datosHeader.consultamulticanal = !this.autenticacionService.MostrarSedeconsulta;
      
      token = Constantes.TIPO_AUTENTICACION() + ' ' + this.autenticacionService.UsuarioActivo.token;
      tokenAutorizacion = Constantes.TIPO_AUTENTICACION() + ' ' + this.autenticacionService.TokenAcceso;
    }

    this._Header = new HttpHeaders({
                                    'Authorization' : token,
                                    'AuthorizationAdditional': JSON.stringify(datosHeader)
                                    }
                                  );

    this._HeaderAutorizacion = new HttpHeaders({
                                    'Authorization' : tokenAutorizacion,
                                    'AuthorizationAdditional': JSON.stringify(datosHeader)
                                    }
                                  );
  }
}
